export default __webpack_public_path__ + "0f7ff97ea87632d61c2a2968a327090c.svg";